export const suppliersConstants = {
    REQUEST: 'REQUEST_SUPPLIERS',
    GET: 'GET_SUPPLIERS',
    GET_ONE: 'GET_ONE',
    FAIL_ONE: 'FAIL_ONE',
    GET_META: 'GET_META',
    GET_COLUMNS: 'GET_COLUMNS',
    FAIL: 'FAIL_SUPPLIERS'
}; 